/* Shared by the employer app, candidate app and TC marketing pages. */
(() => {
  const root = document.documentElement
  if (root.dataset.tcInput) return
  // Preserve visible focus until an actual pointer interaction occurs.
  root.dataset.tcInput = 'keyboard'
  document.addEventListener('pointerdown', () => {
    root.dataset.tcInput = 'pointer'
  }, true)
  document.addEventListener('keydown', event => {
    if (!event.metaKey && !event.ctrlKey && !event.altKey &&
        ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].includes(event.key)) {
      root.dataset.tcInput = 'keyboard'
    }
  }, true)
})()
